import type { GraphViewPreviewable } from '@ipfabric/utils';
import { fetchViews } from 'components/Graph/commands/fetchViews';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface UnstarViewCommand {
  view: GraphViewPreviewable;
}

export const unstarView: GraphCommandFactory<UnstarViewCommand> =
  (cmdContext, dispatch) => async (command) => {
    try {
      cmdContext.updateState((draft) => {
        draft.loadViewDialog.viewIdsBeingUnstarred.add(command.view.id);
      });

      await cmdContext.api.request({
        url: `/graphs/views/${encodeURIComponent(command.view.id)}/favorite`,
        method: 'DELETE',
      });
    } finally {
      try {
        await dispatch(fetchViews);
      } finally {
        cmdContext.updateState((draft) => {
          draft.loadViewDialog.viewIdsBeingUnstarred.delete(command.view.id);
        });
      }
    }
  };
